import * as ProfileActions from "shared/util/ProfileActions";
import {
	OKEVENT,
	subscribeToOkEvent,
} from "shared/util/OkEventHelpers";
import Context from "shared/util/Context";
import OkC from "shared/util/OkcApi";
import Report, { TYPES } from "shared/util/Report";
import { removeUserFromQueues } from "ducks/quickmatch";
import { openConversation } from "ducks/global_messaging";
import { decrementIncomingLikesCount } from "shared/notifications/decrementIncomingLikesCount";

export const LIKE_OBJECTS = {
	profile: "profile",
	photo: "photo",
	essay: "essay",
	question: "question",
};

export const INITIAL_STATE = {
	isMounted: false,
	isLoggedIn: false,

	// profile fields
	essays: [
		/*
			{
				raw_content: "",
				clean_content: "",
				content: "",
				id: 0,
				placeholder: "",
				title: ""
			}
		*/
	],

	likes: {
		they_like: 0,
		you_like: 0,
		passed_on: 0,
		via_boost: 0,
		recycled: 0,
	},

	percentages: {
		match: 0,
		enemy: 0,
	},

	photos: [],
	currentUserThumb: "",

	firstMessage: null,

	blocked: false,
	userid: "",
	username: "",
	displayname: "",

	likedObject: null,
	likedObjectType: null,
	isBlocked: false,
	signupLink: null,

	isLoadingLike: false,
	isLoadingPass: false,
	isLoadingMessage: false,
	isLikesCapModalOpen: false,
	likesCapResetTime: null,
	likesCapRateCardViewCount: 0,
};

function getInitialState() {
	const newState = {
		...INITIAL_STATE,
	};

	// make sure some shit are present
	if (!newState.percentages) {
		newState.percentages = {};
	}

	if (!newState.likes) {
		newState.likes = {};
	}

	if (!newState.essays) {
		newState.essays = [];
	}

	return newState;
}


// action types
// ----------------------------------------------------------------------------

export const SET_STORE = "PROFILE.SET_STORE";
export const LIKE_INITIATED = "PROFILE.LIKE_INITIATED";
export const PASS_INTIATED = "PROFILE.PASS_INTIATED";
export const MESSAGE_INITIATED = "PROFILE.MESSAGE_INITIATED";
export const UNMATCH_INITIATED = "PROFILE.UNMATCH_INITIATED";
export const BLOCK_INITIATED = "PROFILE.BLOCK_INITIATED";
export const UNBLOCK_INITIATED = "PROFILE.UNBLOCK_INITIATED";
export const REPORT_INITIATED = "PROFILE.REPORT_INITIATED";
export const BLOCK_SUCCESS = "PROFILE.BLOCK_SUCCESS";
export const UNBLOCK_SUCCESS = "PROFILE.UNBLOCK_SUCCESS";
export const LIKE_SUCCESS = "PROFILE.LIKE_SUCCESS";
export const PASS_SUCCESS = "PROFILE.PASS_SUCCESS";
export const MESSAGE_SUCCESS = "PROFILE.MESSAGE_SUCCESS";
export const LIKE_CANCELED = "PROFILE.LIKE_CANCELED";
export const PASS_CANCELED = "PROFILE.PASS_CANCELED";
export const MESSAGE_CANCELED = "PROFILE.MESSAGE_CANCELED";
export const REPORT_PHOTO = "PROFILE_BUTTONS.REPORT_PHOTO";
export const OPEN_LIKES_CAP_MODAL = "PROFILE.OPEN_LIKES_CAP_MODAL";
export const INCREMENT_LIKES_CAP_RATE_CARD_VIEW_COUNT = "PROFILE.INCREMENT_LIKES_CAP_RATE_CARD_VIEW_COUNT";
export const MOUNT = "PROFILE.MOUNT";


// reducer
// ----------------------------------------------------------------------------

export function reducer(state = getInitialState(), action) {
	switch (action.type) {
		case MOUNT: {
			return {
				...state,
				isMounted: true,
			};
		}

		case SET_STORE: {
			return {
				...state,
				...action.payload.data,
			};
		}

		case BLOCK_SUCCESS: {
			if (!action.payload.userid || action.payload.userid !== state.userid) {
				return state;
			}

			return {
				...state,
				blocked: true,
			};
		}

		case UNBLOCK_SUCCESS: {
			if (!action.payload.userid || action.payload.userid !== state.userid) {
				return state;
			}

			return {
				...state,
				blocked: false,
			};
		}

		case REPORT_PHOTO: {
			return {
				...state,
			};
		}

		case LIKE_INITIATED: {
			return {
				...state,
				isLoadingLike: true,
			};
		}

		case LIKE_CANCELED: {
			return {
				...state,
				isLoadingLike: false,
			};
		}

		case LIKE_SUCCESS: {
			if (!action.payload.userid || action.payload.userid !== state.userid) {
				return state;
			}

			return {
				...state,
				isLoadingLike: false,

				likes: {
					...state.likes,
					you_like: true,
					passed_on: false,
					mutual_like: action.payload.theyLike,
					they_like: action.payload.theyLike,
					via_spotlight: action.payload.viaBoost,
				},

				likedObjectType: LIKE_OBJECTS[action.payload.type],
				likedObject: action.payload.object,
			};
		}

		case PASS_INTIATED: {
			return {
				...state,
				isLoadingPass: true,
			};
		}

		case PASS_CANCELED: {
			return {
				...state,
				isLoadingPass: false,
			};
		}

		case PASS_SUCCESS: {
			if (!action.payload.userid || action.payload.userid !== state.userid) {
				return state;
			}

			return {
				...state,
				isLoadingPass: false,
				likes: {
					...state.likes,
					you_like: false,
					passed_on: true,
				},

				likedObjectType: null,
				likedObject: null,
			};
		}

		case MESSAGE_INITIATED: {
			return {
				...state,
				isLoadingMessage: true,
			};
		}

		case MESSAGE_CANCELED: {
			return {
				...state,
				isLoadingMessage: false,
			};
		}

		case MESSAGE_SUCCESS: {
			if (!action.payload.userid || action.payload.userid !== state.userid) {
				return state;
			}

			return {
				...state,
				isLoadingMessage: false,
			};
		}

		case OPEN_LIKES_CAP_MODAL: {
			const { payload: { isLikesCapModalOpen } } = action;
			return {
				...state,
				isLoadingLike: false,
				isLikesCapModalOpen,
			};
		}

		case INCREMENT_LIKES_CAP_RATE_CARD_VIEW_COUNT: {
			const {
				payload: { likesCapRateCardViewCount },
			} = action;

			return {
				...state,
				likesCapRateCardViewCount,
			};
		}

		default:
			return state;
	}
}


// actions
// ----------------------------------------------------------------------------

export function setStore(data) {
	return {
		type: SET_STORE,
		payload: {
			data,
		},
	};
}

export function reportPhoto(photoId) {
	return (dispatch, getState) => {
		const { userid } = getState().profile;
		dispatch({ type: REPORT_PHOTO });
		ProfileActions.reportPhoto(userid, photoId);
	};
}

export function openLikesCapModal(isOpen) {
	return {
		type: OPEN_LIKES_CAP_MODAL,
		payload: {
			isLikesCapModalOpen: isOpen,
		},
	};
}

export function like(objectLike, source) {
	return (dispatch, getState) => {
		const state = getState();
		const {
			likes,
			percentages,
			isLoadingLike,
			userid,
			firstMessage,
			photos,
			username,
			displayname,
			currentUserThumb,
		} = state.profile;
		const { lastUserData: userData } = state.quickmatch;

		const {
			you_like: youLike,
		} = likes;

		if (!youLike && !isLoadingLike) {
			dispatch({ type: LIKE_INITIATED });
			dispatch(removeUserFromQueues(userid, { liked: true }));

			ProfileActions.like(userid, {
				matchPercentage: percentages.match,
				firstMessage,
				objectLike,
				photos,
				username,
				displayname,
				userData,
				currentUserThumb,
				source,
			}, () => dispatch(openLikesCapModal(true)));
		}
	};
}

export function pass({ history } = {}, source) {
	return (dispatch, getState) => {
		const state = getState();
		const {
			percentages,
			userid,
			isLoadingPass,
			firstMessage,
		} = state.profile;
		const { lastUserData: userData } = state.quickmatch;

		if (!isLoadingPass) {
			dispatch({ type: PASS_INTIATED });
			dispatch(removeUserFromQueues(userid));

			ProfileActions.pass(userid, {
				firstMessage,
				userData,
				matchPercentage: percentages.match,
				history,
				source,
			});
		}
	};
}

export function message({ likedThisSession } = {}) {
	return (dispatch, getState) => {
		const { userid } = getState().profile;

		dispatch({ type: MESSAGE_INITIATED });

		dispatch(openConversation(userid, { likedThisSession }));
	};
}

export function messageWithObject({ profileComment, likedThisSession } = {}) {
	return (dispatch, getState) => {
		const { userid } = getState().profile;

		dispatch({ type: MESSAGE_INITIATED });
		dispatch(openConversation(userid, { likedThisSession, profileComment }));
	};
}

export function unmatch({ sourceProfile } = {}) {
	return (dispatch, getState) => {
		const { userid, percentages } = getState().profile;

		ProfileActions.unmatch(userid, {
			matchPercentage: percentages.match,
			sourceProfile,
		});

		dispatch({ type: UNMATCH_INITIATED });
		dispatch(removeUserFromQueues(userid));
	};
}


export function block({ sourceProfile, shouldDecrementLikesIncomingCount } = {}) {
	return (dispatch, getState) => {
		const { userid, percentages, likes } = getState().profile;

		ProfileActions.block(userid, {
			matchPercentage: percentages.match,
			sourceProfile,
			shouldDecrementLikesIncomingCount,
			doesCurrentUserLikeTarget: likes.you_like,
		});

		dispatch({ type: BLOCK_INITIATED });
		dispatch(removeUserFromQueues(userid));
	};
}

export function unblock() {
	return (dispatch, getState) => {
		const { userid } = getState().profile;
		ProfileActions.unblock(userid);
		dispatch({ type: UNBLOCK_INITIATED });
	};
}

export function report(userid) {
	Report.open({
		type: TYPES.PROFILE,
		userid,
	});

	return { type: REPORT_INITIATED };
}

export function mount() {
	return (dispatch, getStore) => {
		const { profile } = getStore();
		const { isMounted } = profile;

		if (isMounted) {
			return;
		}

		dispatch({ type: MOUNT });

		// add some event listeners here that react to like actions
		subscribeToOkEvent(OKEVENT.Vote, ({ tuid, liked, mutual, type, objectLike, viaBoost }) => {
			dispatch({
				type: LIKE_SUCCESS,
				payload: {
					userid: tuid,
					youLike: liked,
					theyLike: mutual,
					viaBoost,
					type: type || LIKE_OBJECTS.profile,
				},
			});


			if (Context.has("LIKES_TAB_CLEANUP") && mutual) {
				decrementIncomingLikesCount();
			}

			// after they like someone, open a global messenger thing why not
			if (objectLike) {
				dispatch(messageWithObject({
					profileComment: objectLike,
					likedThisSession: true,
				}));
			} else {
				dispatch(message({ likedThisSession: true }));
			}
		});

		subscribeToOkEvent(OKEVENT.VoteCanceled, () => {
			dispatch({ type: LIKE_CANCELED });
		});

		subscribeToOkEvent(OKEVENT.Pass, ({ tuid }) => {
			dispatch({ type: PASS_SUCCESS, payload: { userid: tuid } });
		});

		subscribeToOkEvent(OKEVENT.PassCanceled, () => {
			dispatch({ type: PASS_CANCELED });
		});

		subscribeToOkEvent(OKEVENT.SentMessage, ({ userid }) => {
			dispatch({ type: MESSAGE_SUCCESS, payload: { userid } });
		});

		subscribeToOkEvent(OKEVENT.SentMessageCanceled, ({ userid }) => {
			dispatch({ type: MESSAGE_CANCELED, payload: { userid } });
		});

		subscribeToOkEvent(OKEVENT.Block, ({ tuid }) => {
			dispatch({ type: BLOCK_SUCCESS, payload: { userid: tuid } });
		});

		subscribeToOkEvent(OKEVENT.Unblock, ({ tuid }) => {
			dispatch({ type: UNBLOCK_SUCCESS, payload: { userid: tuid } });
		});
	};
}

function _incrementLikesCapRateCardViewCount(dispatch, count) {
	dispatch({
		type: INCREMENT_LIKES_CAP_RATE_CARD_VIEW_COUNT,
		payload: {
			likesCapRateCardViewCount: count,
		},
	});
}

export function onIncrementLikesCapModalViewCount() {
	return (dispatch, getState) => {
		const store = getState();
		_incrementLikesCapRateCardViewCount(dispatch, store.profile.likesCapRateCardViewCount + 1);

		OkC.post("/rate_card/view", {
			version: 1,
			data: {
				promo_id: "alist.likescappaywall",
			},
		})
			.then(({ view_count: viewCount }) => {
				_incrementLikesCapRateCardViewCount(dispatch, viewCount);
			});
	};
}



// WEBPACK FOOTER //
// ./src/ducks/profile.js